import React, {useEffect} from "react";
import Filters from "../Filters";
import {useGetHouses, useGetMyHouses, useHouses, useMyHouses} from "../stores/otherStore";
import HouseCard from "../HouseCard";
import {useLocation} from "react-router-dom";
import Buttons from "../Buttons";

const ResultDetail = () => {
    const houses = useHouses();
    const getHouses = useGetHouses();
    const location = useLocation();
    const {
        category,
        district,
        q,
        min_price_som,
        max_price_som,
        created_from,
        created_to,
    } = location.state || {};

    const token = localStorage.getItem("access_token");

    useEffect(() => {
        void getHouses(category?.id, district, q, min_price_som, max_price_som, created_from, created_to);
    }, [
        category,
        district,
        q,
        min_price_som,
        max_price_som,
        created_from,
        created_to,
        getHouses,
        token,
    ]);

    return (
        <div className="bg-cover py-5"
             style={{backgroundImage: `url(https://i.pinimg.com/originals/4b/0b/88/4b0b8812bbda1a66e0100e7a962b5f77.jpg)`}}>
            <div className={'max-w-screen-xl mx-auto bg-white/20 backdrop-blur-lg rounded-xl shadow-lg'}>
                <Filters
                    cat={category}
                    dis={district}
                    title={q}
                    min={min_price_som}
                    max={max_price_som}
                    from={created_from}
                    to={created_to}
                />
                <Buttons/>
                <p className="my-3 px-5 mx-auto text-white text-lg lg:w-11/12 md:w-11/12">Результаты найденных обьявлений: {houses.length}</p>

                <div className="w-full px-16 pb-5 md:px-0 min-h-[50vh]">
                    {houses.length === 0 && (
                        <div
                            className="border w-fit bg-white/20 mx-auto border-gray-200 flex mt-10 flex-col items-center justify-center px-4 md:px-8 lg:px-24 py-8 rounded-lg shadow-2xl">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-search"
                                style={{color: "rgb(160, 174, 192)", fontSize: "48px", marginBottom: "16px"}}
                            >
                                <circle cx="11" cy="11" r="8"></circle>
                                <path d="m21 21-4.3-4.3"></path>
                            </svg>
                            <p className="text-white mt-4 pb-4 border-b-2 text-center">
                                По вашему запросу ничего не найдено
                            </p>
                        </div>
                    )}

                    <div className="flex lg:w-11/12 px-3 bg-white/40 rounded-xl md:w-11/12 mx-auto flex-wrap lg:gap-14">
                        {houses.map((house) => (
                            <HouseCard key={house.id} house={house}/>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResultDetail;
